/* ============================================================
   cs-cart-drawer.js   -   section: cs-cart-drawer
   Renders the cart from /cart.js, takes over every add to cart form
   and cart link, and handles checkout with or without protection.

   No prices or variant IDs in here. Protection variants come from
   CS.variant(handle, title), see sections/cs-cart-drawer.liquid.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-cs-cart-drawer]');
  if (!root || root.dataset.csReady) return;
  root.dataset.csReady = '1';

  var cfg = root.dataset;
  var panel = root.querySelector('.cs-cd__panel');
  var body = root.querySelector('[data-cs-cart-body]');
  var foot = root.querySelector('[data-cs-cart-foot]');
  var flash = root.querySelector('[data-cs-flash]');
  var lastFocus = null;
  var cart = null;
  var busy = false;

  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function money(c) { return window.CS ? CS.money(c) : (c / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function q(sel) { return root.querySelector(sel); }

  /* ---------- protection ---------- */
  /* One variant per tier, so checkout shows a single protection line.
     Cheapest variant = under the start amount, the next = start to
     start+every, and so on. The most expensive variant is the cap. */
  function protVariants() {
    if (cfg.protEnabled !== 'true' || !window.CS) return null;
    var p = CS.product(cfg.protHandle);
    if (!p || !p.variants.length) return null;
    return p.variants.slice().sort(function (a, b) { return a.price - b.price; });
  }

  function isProt(item) { return item.handle === cfg.protHandle; }

  /* Shopify.theme.role is "main" only on the published theme. */
  function isLiveTheme() {
    return !(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  }

  /* The single tier variant protection should add for a merchandise subtotal. */
  function protPlan(subtotal) {
    var tiers = protVariants();
    if (!tiers || subtotal <= 0) return null;
    var start = Number(cfg.protStart) || 0;
    var every = Number(cfg.protEvery) || 0;
    var i = 0;
    if (tiers.length > 1 && subtotal >= start) i = 1 + (every > 0 ? Math.floor((subtotal - start) / every) : 0);
    var v = tiers[Math.min(i, tiers.length - 1)];
    return { lines: [{ v: v, qty: 1 }], total: v.price, all: [] };
  }

  /* ---------- render ---------- */
  function render(c) {
    cart = c;
    var items = (c.items || []).filter(function (i) { return !isProt(i); });
    var subtotal = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var count = items.reduce(function (s, i) { return s + i.quantity; }, 0);

    q('[data-cs-cart-count]').textContent = count;

    if (!items.length) {
      var tpl = root.querySelector('[data-cs-empty-tpl]');
      body.innerHTML = '';
      if (tpl) body.appendChild(tpl.content.cloneNode(true));
      else body.innerHTML = '<div class="cs-cd__empty"><a class="cs-button" href="' + esc(cfg.shopUrl) + '">Shop All</a></div>';
      foot.hidden = true;
      q('[data-cs-free]').hidden = true;
      return;
    }

    body.innerHTML = '<ul class="cs-cd__items" role="list">' + items.map(function (i) {
      var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      var opts = (i.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' &middot; ');
      var was = i.original_line_price > i.final_line_price ? '<s>' + money(i.original_line_price) + '</s>' : '';
      return '<li class="cs-cd__item" data-key="' + esc(i.key) + '">' +
        '<a class="cs-cd__thumb" href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="120" height="150">' : '') + '</a>' +
        '<div class="cs-cd__info">' +
          '<a class="cs-cd__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (opts ? '<span class="cs-cd__opts">' + opts + '</span>' : '') +
          '<div class="cs-cd__line">' +
            '<div class="cs-cd__qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-cs-qty="' + (i.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + i.quantity + '</span>' +
              '<button type="button" data-cs-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cs-cd__price">' + was + money(i.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cs-cd__remove" data-cs-qty="0" aria-label="Remove ' + esc(i.product_title) + '">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</li>';
    }).join('') + '</ul>';

    foot.hidden = false;
    q('[data-cs-subtotal]').textContent = money(subtotal);

    /* free shipping */
    var threshold = Number(cfg.freeThreshold) || 0;
    var free = q('[data-cs-free]');
    if (threshold > 0) {
      free.hidden = false;
      var left = threshold - subtotal;
      var pct = Math.max(0, Math.min(1, subtotal / threshold));
      q('[data-cs-free-fill]').style.transform = 'scaleX(' + pct + ')';
      free.classList.toggle('is-done', left <= 0);
      q('[data-cs-free-text]').innerHTML = left <= 0
        ? '<b>Free shipping</b> unlocked'
        : 'You\'re <b>' + money(left) + '</b> away from free shipping';
    } else {
      free.hidden = true;
    }

    /* protection */
    var plan = protPlan(subtotal);
    var prot = q('[data-cs-prot]');
    var withBtn = q('[data-cs-checkout="with"]');
    var without = q('[data-cs-checkout="without"]');
    prot.classList.remove('is-setup');
    if (plan) {
      prot.hidden = false;
      q('[data-cs-prot-price]').textContent = '+' + money(plan.total);
      q('[data-cs-checkout-label]').innerHTML = 'Checkout with protection &middot; ' + money(subtotal + plan.total);
      without.hidden = false;
    } else if (cfg.protEnabled === 'true' && !isLiveTheme()) {
      /* Product not created yet. On preview and unpublished themes only, show
         where the row goes so it can be reviewed. Never on the live theme,
         and nothing is charged: checkout stays plain. */
      prot.hidden = false;
      prot.classList.add('is-setup');
      q('[data-cs-prot-price]').textContent = 'Setup needed';
      q('[data-cs-checkout-label]').innerHTML = 'Checkout &middot; ' + money(subtotal);
      without.hidden = true;
    } else {
      prot.hidden = true;
      q('[data-cs-checkout-label]').innerHTML = 'Checkout &middot; ' + money(subtotal);
      without.hidden = true;
    }
    withBtn.dataset.plan = plan ? '1' : '';
  }

  function showFlash(msg) {
    flash.textContent = msg;
    flash.hidden = !msg;
    if (msg) setTimeout(function () { flash.hidden = true; }, 5000);
  }

  /* ---------- cart api ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshBubble() {
    /* cs-header: just update the badge on the shoebox. */
    var badges = document.querySelectorAll('[data-cs-cart-badge]');
    if (badges.length) {
      var n = cart ? (cart.items || []).filter(function (i) { return !isProt(i); })
        .reduce(function (s, i) { return s + i.quantity; }, 0) : 0;
      badges.forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
      var link = document.querySelector('[data-cs-cart-link]');
      if (link) link.setAttribute('aria-label', 'Cart, ' + n + ' items');
      return Promise.resolve();
    }
    /* Fallback for Dawn's header: re-render its own cart icon section. */
    return fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !s['cart-icon-bubble']) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var src = doc.querySelector('.shopify-section') || doc.body;
        el.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function refresh() {
    return getCart().then(function (c) { render(c); refreshBubble(); return c; });
  }

  function setBusy(on) {
    busy = on;
    root.classList.toggle('is-busy', on);
  }

  function changeQty(key, qty) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (c) { render(c); refreshBubble(); })
      .catch(function (e) { showFlash((e && (e.description || e.message)) || 'Could not update the cart.'); refresh(); })
      .then(function () { setBusy(false); });
  }

  /* Set protection lines to exactly what the plan says, then go to checkout. */
  function checkout(withProt) {
    if (busy) return;
    setBusy(true);
    var go = function () { window.location.href = '/checkout'; };

    getCart().then(function (c) {
      var items = (c.items || []).filter(function (i) { return !isProt(i); });
      var subtotal = items.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var plan = protPlan(subtotal);
      var updates = {};
      var hasProt = (c.items || []).some(isProt);

      if (plan) plan.all.forEach(function (v) { updates[v.id] = 0; });
      (c.items || []).forEach(function (i) { if (isProt(i)) updates[i.variant_id] = 0; });
      if (withProt && plan) plan.lines.forEach(function (l) { updates[l.v.id] = l.qty; });

      if (!hasProt && !(withProt && plan)) return null;
      return fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (e) { console.warn('[CS] protection update failed', e); }); });
    }).then(go, go);
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root.hidden && root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; /* commit the unhidden state so the slide-in still animates */
    root.classList.add('is-open');
    panel.focus({ preventScroll: true });
    document.documentElement.classList.add('cs-cd-lock');
  }
  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('cs-cd-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Public, so the /cart page (cs-cart.js) runs the exact same protection
     maths and checkout as the drawer instead of a second copy of it. */
  window.CSCart = {
    open: function () { refresh(); open(); },
    close: close,
    refresh: refresh,
    plan: protPlan,
    isProtection: isProt,
    checkout: checkout
  };

  /* ---------- wiring ---------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cs-cart-close]')) { close(); return; }
    var qty = e.target.closest('[data-cs-qty]');
    if (qty) {
      var li = qty.closest('[data-key]');
      if (li) changeQty(li.dataset.key, Number(qty.dataset.csQty));
      return;
    }
    var co = e.target.closest('[data-cs-checkout]');
    if (co) checkout(co.dataset.csCheckout === 'with');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    if (e.key === 'Tab' && root.classList.contains('is-open')) {
      var f = panel.querySelectorAll('a[href], button:not([disabled]):not([hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Cart icon and any link to /cart open the drawer. Capture phase, so this
     runs before Dawn's own header handler. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if (!a || root.contains(a)) return;
    e.preventDefault();
    e.stopPropagation();
    window.CSCart.open();
  }, true);

  /* Every add to cart form on the site, including Dawn's product form. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refresh(); })
      .then(function () { showFlash(''); open(); })
      .catch(function (err) {
        refresh();
        open();
        showFlash((err && (err.description || err.message)) || 'Could not add that to your cart.');
      })
      .then(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } });
  }, true);

  /* "?" on the protection row, in the drawer and on the /cart page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-prot-info-toggle]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  });

  /* Came back from checkout with the back button: re-read the cart. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
